// extracted by mini-css-extract-plugin
export default {"dialogBody":"UploadImagesDialog_dialogBody__OfuP8"};